import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { FIRMWARE } from '../../../../../store/utils/files-names';
import { FirmwareHeaderAndPaginationFilters } from '../../../models/firmware-header-and-pagination-filters.model';

export const getFirmwareFiltersSelector = (
  state: AppRootState
): FirmwareHeaderAndPaginationFilters => get(state, FIRMWARE).filters;
